export const PREPARE_FINAL_OBJECT = "PREPARE_FINAL_OBJECT";
